import { useEffect } from "react";
import Media from '../Media';



function ArticleVideoFull ( props ){

	useEffect(() => {
		// window.scrollTo(window.scrollX, window.scrollY+1);
		// window.scrollTo(window.scrollX, window.scrollY-1);
		// eslint-disable-next-line
	},[])

	return (
		<div 	className={`article article--${props.article.content_display || 'default'} ${props.addClass || ''}`} >

            <div className="article__content">
                <div className="article__content-wrapper">
                    { props.article.title !== '' && 
                        <h2 id={props.article.slug}>
                            {props.article.title}
                        </h2>
                    }

                    { props.article.subtitle !== '' && 
                        <h3>{props.article.subtitle}</h3>
                    }

                    <p dangerouslySetInnerHTML={{__html: props.article.description}} />
                </div>
            </div>

			{ props.article.media.length > 0 && 
				<div className="article__video">
					<Media 
						media={props.article.media[0]} 
						lightbox={false}
						cdnParams="&width=1400&height=900&func=crop"
					/>
				</div>
			}
			
		</div>
	);

}

export default ArticleVideoFull;